import { Box, Dialog, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useAvailabilities } from "../AvailabilitiesProvider";
import AvailabilityItem from "./AvailabilityItem";

const AvailabilityDetailModal = () => {
  const { selectedDate, setSelectedDate, getAvailabilitiesForDate } =
    useAvailabilities();

  const isOpen = selectedDate !== null;
  const availabilities = selectedDate
    ? getAvailabilitiesForDate(selectedDate)
    : [];

  const sortedAvailabilities = [...availabilities].sort((a, b) => {
    const aTime = a.isFareharbor
      ? (a.availability as any).start_at
      : a.availability.start_time;
    const bTime = b.isFareharbor
      ? (b.availability as any).start_at
      : b.availability.start_time;
    return new Date(aTime).getTime() - new Date(bTime).getTime();
  });

  const formattedDate = selectedDate
    ? dayjs(selectedDate).format("dddd, MMMM D, YYYY")
    : "";

  const handleClose = () => setSelectedDate(null);

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: 2, maxHeight: "80vh" } }}
    >
      <Box sx={{ p: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 3 }}>
          {formattedDate}
        </Typography>

        {sortedAvailabilities.length === 0 ? (
          <Typography sx={{ textAlign: "center", py: 4, color: "#666" }}>
            No availability found for this date.
          </Typography>
        ) : (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            {sortedAvailabilities.map((availability) => (
              <AvailabilityItem
                key={`${availability.item.id}-${availability.availabilityId}`}
                availability={availability}
              />
            ))}
          </Box>
        )}
      </Box>
    </Dialog>
  );
};

export default AvailabilityDetailModal;
